import React, { useEffect } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Box from '@material-ui/core/Box';
import grey from '@material-ui/core/colors/grey';
import LoginForm from 'login/LoginForm';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { useSubClient } from 'graphql/client';

interface Props {}

const useStyles = makeStyles((theme: Theme) => ({
  bg: { backgroundColor: theme.palette.grey[500] },
  logo: { maxHeight: 340, objectFit: 'contain', paddingTop: theme.spacing(1) },
}));

const Login = (props: Props) => {
  const classes = useStyles();
  const subClient = useSubClient();

  useEffect(() => {
    subClient.close();
  }, [subClient]);

  return (
    <Box minHeight="100vh" bgcolor={grey[300]}>
      <Box width="90%" maxWidth={600} paddingTop={3} margin="0px auto">
        <Card>
          <CardMedia
            className={classes.logo}
            component="img"
            image="/msd_logo.png"
            title="logo"
            alt="logo"
          />
          <CardContent>
            <LoginForm />
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default Login;
